import { Button, Modal } from "antd";
import React from "react";

export default function ModalConfirm({
  dataMembership,
  modalConfirm,
  setModalConfirm,
  submitting,
  markAsAgent,
  data,
}) {
  return (
    <Modal
      title={
       !dataMembership?.isAgent
          ? "Yakin Ingin Menambahkan Nasabah sebagai Agen?"
          : "Yakin Ingin Menghapus Nasabah dari Agen?"
      }
      visible={modalConfirm}
      onCancel={() => setModalConfirm(false)}
      width={500}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={() => setModalConfirm(false)}
          className="btn-modal btn-default"
          style={{ width: 100 }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type="primary"
          onClick={markAsAgent}
          className="btn-modal"
          style={{ width: 100 }}
        >
          Yakin
        </Button>,
      ]}
    >
      <div className="py-2">
        {!dataMembership?.isAgent
          ? `Anda akan menambahkan ${data?.ktp_name?.toUpperCase()} sebagai agen.`
          : `Anda akan menghapus ${data?.ktp_name?.toUpperCase()} dari agen.`}
      </div>
    </Modal>
  );
}
